import Axios, { AxiosInstance } from 'axios';
import ICommonHttpError from '../../models/ICommonHttpError';
import IHttpClient from './IHttpClient';

export const isCommonHttpError = (error: ICommonHttpError): error is ICommonHttpError => {
  return Boolean(error.httpStatus);
};

function convertErrorToSomethingICanWorkWithAndImproveItWithTime(error: any): ICommonHttpError {
  const message: string = error && error.response && error.response.data ? error.response.data.message : null;
  const code: string = error && error.response && error.response.data ? error.response.data.code : null;
  const reasonCode: number = error && error.response && error.response.data ? error.response.data.reasonCode : null;
  const errorCode: string = error && error.response && error.response.data ? error.response.data.errorCode : null;
  const httpStatus: number = error && error.response ? error.response.status : 500;
  const externalPurchaseId: number = error && error.response && error.response.data ? error.response.data.externalPurchaseId : null;

  return {
    code,
    httpStatus,
    message,
    reasonCode,
    errorCode,
    externalPurchaseId
  };
}

function httpClient(): IHttpClient {

  const instance: AxiosInstance = Axios.create({
    baseURL: ''
  });

  const instanceCard = Axios.create({
    baseURL: '',
    timeout: 30000
  });

  instance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    return Promise.reject(convertErrorToSomethingICanWorkWithAndImproveItWithTime(error));
  });

  instanceCard.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    return Promise.reject(convertErrorToSomethingICanWorkWithAndImproveItWithTime(error));
  });

  return {
    setBaseUrl(baseUrl: string , baseUrlCard? : string ) {
      instance.defaults.baseURL = baseUrl;
      instanceCard.defaults.baseURL = baseUrlCard !==null ? baseUrlCard : baseUrl;
      return this;
    },
    setHeader(header: string, value: string | null) {
      if (value === null) {
        delete instance.defaults.headers.common[header]; // tslint:disable-line:no-string-literal
        delete instanceCard.defaults.headers.common[header]; // tslint:disable-line:no-string-literal
      }
      else {
        instance.defaults.headers.common[header] = value;
        instanceCard.defaults.headers.common[header] = value;
      }
      return this;
    },
    get: instance.get,
    post: instance.post,
    put: instance.put,
    del: instance.delete,
    delCard: instanceCard.delete,
    getCard: instanceCard.get,
    postCard: instanceCard.post,
    putCard: instanceCard.put,
  };
}

export default httpClient;
